var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_900_25477",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_900_25477)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.95882 21.5C4.41471 21.5 3.95221 21.3096 3.57132 20.9287C3.19044 20.5478 3 20.0853 3 19.5412V4.95882C3 4.41471 3.19044 3.95221 3.57132 3.57132C3.95221 3.19044 4.41471 3 4.95882 3H19.5412C20.0853 3 20.5478 3.19044 20.9287 3.57132C21.3096 3.95221 21.5 4.41471 21.5 4.95882V19.5412C21.5 20.0853 21.3096 20.5478 20.9287 20.9287C20.5478 21.3096 20.0853 21.5 19.5412 21.5H4.95882ZM4.95882 19.8676H11.4338V4.63235H4.95882C4.88627 4.63235 4.81373 4.66863 4.74118 4.74118C4.66863 4.81373 4.63235 4.88627 4.63235 4.95882V19.5412C4.63235 19.6137 4.66863 19.6863 4.74118 19.7588C4.81373 19.8314 4.88627 19.8676 4.95882 19.8676ZM13.0662 19.8676H19.5412C19.6137 19.8676 19.6863 19.8314 19.7588 19.7588C19.8314 19.6863 19.8676 19.6137 19.8676 19.5412V12.25H13.0662V19.8676ZM13.0662 10.6176H19.8676V4.95882C19.8676 4.88627 19.8314 4.81373 19.7588 4.74118C19.6863 4.66863 19.6137 4.63235 19.5412 4.63235H13.0662V10.6176Z",
    fill: "#252525"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard_icon.4caa93e0fe3abddf528d73c552db5132.svg";
export { ForwardRef as ReactComponent };